import {ComponentFactoryResolver, Directive, EventEmitter, Input, OnChanges, OnDestroy, Output, ViewContainerRef} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {FieldConfig, FieldType} from '../field.interface';
import {InputComponent} from '../input/input.component';
import {ButtonComponent} from '../button/button.component';
import {SelectComponent} from '../select/select.component';
import {DateComponent} from '../date/date.component';
import {RadiobuttonComponent} from '../radiobutton/radiobutton.component';
import {CheckboxComponent} from '../checkbox/checkbox.component';
import {Subscription} from 'rxjs';
import {AttachmentComponent} from '../attachment/attachment.component';
import {TextareaComponent} from '../textarea/textarea.component';
import {DateRangeComponent} from '../date-range/dateRange.component';

const componentMapper = {
  input: InputComponent,
  button: ButtonComponent,
  select: SelectComponent,
  attachment: AttachmentComponent,
  date: DateComponent,
  dateRange: DateRangeComponent,
  radiobutton: RadiobuttonComponent,
  checkbox: CheckboxComponent,
  textarea: TextareaComponent
};
@Directive({
    selector: '[appDynamicField]',
    standalone: false
})
export class DynamicFieldDirective implements OnChanges, OnDestroy {
  @Input() field: FieldConfig;
  @Input() group: UntypedFormGroup;
  // @Input() visible = true;
  @Output() selectedValue = new EventEmitter();
  @Output() cancelForm = new EventEmitter();
  componentRef: any;
  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef
  ) { }
  ngOnDestroy(): void {
    this.componentRef.destroy();
  }
  ngOnChanges() {
    this.clear();
    const factory = this.resolver.resolveComponentFactory(
      componentMapper[this.field.type]
    );
    this.componentRef = this.container.createComponent(factory);
    this.componentRef.instance.field = this.field;
    this.componentRef.instance.group = this.group;
    if (this.field.type === FieldType.select || this.field.type === FieldType.checkbox) {
      const sub: Subscription = this.componentRef.instance.selectedValue.subscribe(data => {
        this.selectedValue.emit(data);
      });
      this.componentRef.onDestroy(() => { sub.unsubscribe(); });
    }

    // if (!this.visible) {
    //   this.componentRef.destroy();
    // }

  }
  clear() {

    this.container.clear();
  }

}
